<div #alarmTooltip
    class="alarm-number badge-wrap"
    [nTooltip]="alarmDropdown"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    nTooltipPlacement="bottom"
    nTooltipOverlayClass="alarm-dropdown-panel"
    [(nTooltipVisible)]="tooltipVisible">
    <div [nTooltip]="isSimpleMode ? i18n.alarmTip : null" nTooltipPlacement="bottom">
        <svg class="icon header-icon">
            <use xlink:href="#app-icon-header-alarm-simple"></use>
        </svg>
        <app-badge-num [total]="total"></app-badge-num>
    </div>
</div>

<!-- 告警下拉列表 -->
<ng-template #alarmDropdown>
    <div class="header">
        <span class="dropdown-title">
            {{i18n.recentAlarm}}
        </span>
    </div>
    <div class="body">
        <div *ngFor="let alarm of recent.alarms"
            class="alarmLabel clearfix alarm-info"
            (click)="viewAlarm(alarm)">
            <svg class="alarm-icon">
                <use [attr.xlink:href]="str.levelIcon[alarm.level]"></use>
            </svg>

            <div class="alarm-info-left">
                <p class="alarm-name" nTextTips>{{alarm.name}}</p>
                <p class="alarm-time">{{alarm.startTimeStr}}</p>
            </div>

            <div class="alarm-info-right"></div>
        </div>
        <!-- 加载中提示 -->
        <div *ngIf="recent.isLoading" class="alarm-loading">
            <svg class="icon uploading">
                <use xlink:href="#icon-loading"></use>
            </svg>
        </div>

        <!-- 无数据提示 -->
        <div *ngIf="recent.noData" class="alarm-nodata">
            <div class="alarm-nodata-inner">
                {{i18n.noData}}
            </div>
        </div>
    </div>
    <div class="footer">
        <a [routerLink]="[allAlarmRouter]" [queryParams]="{event: 'alarm'}" (click)="viewAllAlarm()">{{i18n.viewAllAlarm}}</a>
        <span>
            <svg class="icon"
                (click)="soundSwitchClick()"
                [nTooltip]="alarmVoiceEnabled ? i18n.turnOnSound : i18n.turnOffSound">
                <use *ngIf="alarmVoiceEnabled" xlink:href="#app-icon-voice-disable"></use>
                <use *ngIf="!alarmVoiceEnabled" xlink:href="#app-icon-voice-enable"></use>
            </svg>
            <svg class="icon"
                (click)="viewAlarmsSetting($event)"
                [nTooltip]="i18n.soundSetting"
                nTooltipPlacement="bottomLeft">
                <use xlink:href="#app-icon-setting"></use>
            </svg>
        </span>
    </div>
</ng-template>
<!-- 设置页 -->
<app-alarms-setting #alarmsSetting
    *ngIf="isShowAlarmSetting"
    [(show)] = "isShowAlarmSetting"
    (settingSave)="onSettingSave()">
</app-alarms-setting>
